import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-quantity-and-size',
  templateUrl: './header-column-quantity-and-size.component.html',
  styleUrls: ['./header-column-quantity-and-size.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnQuantityAndSizeComponent extends HeaderColumnComponent {}
